import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "lot-live" }
const _hoisted_2 = { class: "lot-border-content" }
const _hoisted_3 = {
  key: 0,
  class: "lot-status-badge"
}
const _hoisted_4 = { class: "lot-top-block" }
const _hoisted_5 = { class: "lot-number" }
const _hoisted_6 = {
  key: 0,
  class: "lot-icons"
}
const _hoisted_7 = { class: "lot-image" }
const _hoisted_8 = ["src", "alt"]
const _hoisted_9 = {
  key: 0,
  class: "lot-card-note"
}
const _hoisted_10 = {
  key: 1,
  class: "lot-title"
}

import FavoriteButton from "@/components/_partials/FavoriteButton.vue";
  import { computed, inject, onMounted, onUnmounted, ref } from "vue";
  import { ILot } from "@/models";
  import { LotStatuses, LotSoldStatuses } from "@/enum";
  import { trans } from "@/utils/trans";
  import { format_currency } from "@/utils/currencies";
  import { useAuctionStore } from "@/stores/AuctionStore";
  import apiClient from "@/services/api";
  import { useToast } from "primevue/usetoast";
  import { createTooltip, destroyTooltip } from "floating-vue";
  import { BaseIcon, BellIcon } from "@/components/icons";
  import BellFillIcon from "@/components/icons/BellFillIcon.vue";
  
export default /*#__PURE__*/_defineComponent({
  __name: 'LotCard',
  props: {
    lotData: {},
    withTitle: { type: Boolean, default: false },
    catalogPopup: { type: Boolean, default: false }
  },
  setup(__props: any) {

  const emitter = inject("emitter");
  const toast = useToast();

  const props = __props;

  const auctionStore = useAuctionStore();
  const noteRef = ref<HTMLDivElement>();

  const isLive = computed(() => props.lotData.status === LotStatuses.LIVE);
  const isShowAlert = computed(() => props.lotData.sold_status === LotSoldStatuses.PREPARED && !isLive.value);
  const title = computed(() => props.lotData?.title);

  const note = computed(() => {
    let result = null;
    if (auctionStore.user?.id && !auctionStore.user?.is_admin) {
      result = props.lotData.note?.length ? props.lotData.note : null;
    } else if (auctionStore.user?.is_admin) {
      result = props.lotData.admin_notes?.length ? props.lotData.admin_notes : null;
    }
    return result;
  });

  const buttonText = computed(() => {
    if (isLive.value) {
      return trans("live.catalog.lot_card.is_live");
    } else {
      return format_currency(props.lotData?.current_bid);
    }
  });

  onMounted(() => {
    if (noteRef.value) {
      createTooltip(
        noteRef.value,
        {
          triggers: ["hover", "touch"],
          theme: "info-tooltip",
          placement: "top",
          distance: 10,
          skidding: 10,
          popperClass: "fit-content",
          content: `<div class="info-tooltip wide">${note.value}</div>`,
          html: true
        },
        null
      );
    }
  });

  onUnmounted(() => {
    if (noteRef.value) {
      destroyTooltip(noteRef.value);
    }
  });

  const openLotAlertSetting = () => {
    if (props.lotData.alert_enabled) {
      apiClient.delete(`/live/lots/${props.lotData.id}/alert`).then(() => {
        auctionStore.$patch((storeState) => {
          let lotIndex = storeState.lots.findIndex((lot) => lot.id === props.lotData.id);
          if (lotIndex >= 0) {
            storeState.lots[lotIndex].alert_enabled = false;
          }
          lotIndex = storeState.catalog?.searchLots?.findIndex((lot) => lot.id === props.lotData.id);
          if (lotIndex >= 0) {
            storeState.catalog.searchLots[lotIndex].alert_enabled = false;
          }
        });

        toast.add({
          severity: "success",
          summary: trans("live.toast.success"),
          detail: trans("live.toast.live_lot_alert.disable_success"),
          life: 6000
        });
      });
    } else {
      apiClient.get(`/live/lots/${props.lotData.id}/alert`).then((response) => {
        emitter?.emit("on:live-lot-alerts:modal-show", {
          title: `${props.lotData?.lot_number} ${props.lotData?.title}`,
          lotId: response.data.lot_id,
          settings: response.data.settings
        });
      });
    }
  };

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (props.lotData.sold_status === _unref(LotSoldStatuses).SOLD)
        ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_unref(trans)("live.catalog.lot_card.sold")), 1))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(trans)("live.catalog.lot_card.lot_number", { number: props.lotData.lot_number })), 1),
        (_unref(auctionStore).user?.id)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              (isShowAlert.value)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: _normalizeClass(['notify-block', { active: _ctx.lotData.alert_enabled }]),
                    onClick: _withModifiers(openLotAlertSetting, ["stop","prevent"])
                  }, [
                    _createVNode(_unref(BaseIcon), {
                      "icon-name": "bell",
                      width: "19",
                      height: "19",
                      "view-box": "0 0 19 19"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(BellIcon))
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(BaseIcon), {
                      "icon-name": "bell-fill",
                      width: "16",
                      height: "20",
                      "view-box": "0 0 16 20"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(BellFillIcon)
                      ]),
                      _: 1
                    })
                  ], 2))
                : _createCommentVNode("", true),
              (props.lotData?.id)
                ? (_openBlock(), _createBlock(FavoriteButton, {
                    key: 1,
                    "lot-id-prop": props.lotData.id
                  }, null, 8, ["lot-id-prop"]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("img", {
          class: "img",
          src: props.lotData?.main_image,
          loading: "lazy",
          alt: props.lotData?.title,
          width: "113",
          height: "127"
        }, null, 8, _hoisted_8),
        (note.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              (_ctx.catalogPopup && note.value)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: _normalizeClass(['lot-bottom', { live: isLive.value, 'catalog-popup on-note': _ctx.catalogPopup }])
                  }, _toDisplayString(buttonText.value), 3))
                : _createCommentVNode("", true),
              _createElementVNode("div", {
                class: "note",
                ref_key: "noteRef",
                ref: noteRef
              }, _toDisplayString(note.value), 513)
            ]))
          : _createCommentVNode("", true),
        (_ctx.catalogPopup && !note.value)
          ? (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: _normalizeClass(['lot-bottom', { live: isLive.value, 'catalog-popup': _ctx.catalogPopup }])
            }, _toDisplayString(buttonText.value), 3))
          : _createCommentVNode("", true)
      ]),
      (title.value && props.withTitle)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(title.value), 1))
        : _createCommentVNode("", true),
      (!_ctx.catalogPopup)
        ? (_openBlock(), _createElementBlock("div", {
            key: 2,
            class: _normalizeClass(['lot-bottom', { live: isLive.value }])
          }, _toDisplayString(buttonText.value), 3))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})